export default __webpack_public_path__ + "static/media/Verbinding met educaties.ae2915ad.pdf";